import _ from "lodash";

export const ACTIONS = {
  UPDATE_SETTING_ROW: "update-setting-row",
  CALL_GET_API: "call-get-api",
  SUCCESS: 'success',
  ERROR: 'error'
}

export const settingListReducer = (state, action) => {
  switch (action.type){
    case ACTIONS.CALL_GET_API: {
      return {...state, loading: true}
    }
    case ACTIONS.SUCCESS: {
      return {...state, loading: false, settings: action.data}
    }
    case ACTIONS.ERROR: {
      return {...state, loading: false, error: action.error}
    }
    case ACTIONS.UPDATE_SETTING_ROW: {
      let tmpSetting = _.cloneDeep(state.settings);
      let updatedIndex = state.settings.findIndex(x => x.id === action.data.id);
      if(updatedIndex > -1){
        tmpSetting[updatedIndex] = action.data
      }

      return {...state, loading: false, settings: tmpSetting}
    }
  }
}